import { createResourceAtom } from 'lib/atoms';
import { useMemo } from 'react';
import { StateResponse } from 'types/api-responses';

const useStatesAtom = (href?: string) => {
  return useMemo(() => createResourceAtom<StateResponse[]>(href), [href]);
};

export { useStatesAtom };
